import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useResetMutation } from "./resetApiSlice";
import { showLoader, hideLoader } from "../../app/api/appApiSlice";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [reset, { isSuccess, isError }] = useResetMutation();

  const [username, setUsername] = useState("");
  const [errUsername, setErrUsername] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username) {
      setErrUsername(true);
    }

    if (!username) {
      return;
    }

    try {
      dispatch(showLoader());
      await reset({ username }).unwrap();
    } catch (err) {
      if (err.data?.message) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg("Please try again later.!");
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      setErrMsg("");

      setTimeout(async () => {
        setUsername("");

        dispatch(hideLoader());

        navigate("/update-password");
      }, 3000);
    }

    if (isError) {
      dispatch(hideLoader());
    }
  }, [isSuccess, isError]);

  return (
    <section className="flex items-center justify-center xs:min-h-[calc(100vh-68px)] py-10 mx-auto">
      <div className="flex items-center justify-center flex-wrap gap-16 sm:gap-40 p-4 xs:p-8 sm:p-20 mx-auto rounded-xl xs:shadow-lg">
        <div className="text-center">
          <img
            className="w-[300px] mx-auto mb-4"
            src="/img/dashboard.png"
            alt="intro image"
          />
          <p className="text-base sm:text-2xl">
            If you are already member?
            <br />
            Please go to the signin page.
          </p>
          <div className="mt-4">
            <Link
              className="inline-block bg-black text-white uppercase p-3 rounded-md"
              to="/"
            >
              Sign In
            </Link>
          </div>
        </div>
        <div className="flex flex-col justify-center xs:justify-start w-[300px] max-w-[calc(100%-30px)]">
          <h1 className="text-3xl text-center uppercase mb-6">
            Forget Password
          </h1>
          <form method="post" onSubmit={handleSubmit}>
            <div className="mb-4">
              <div
                className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                  errUsername && "text-error border-error"
                }`}
              >
                <label htmlFor="username" className="block text-xs">
                  Username *
                </label>
                <input
                  id="username"
                  name="username"
                  type="email"
                  className="focus-visible:outline-none"
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(e.target.value)) {
                      setErrUsername(true);
                    } else {
                      setErrUsername(false);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              {errUsername && (
                <span className="text-xs text-error">
                  Please enter a valid email address.
                </span>
              )}
            </div>
            <div className="text-center mt-4">
              <button
                type="submit"
                className="max-w-fit bg-black text-white uppercase p-3 rounded-md"
              >
                Reset Password
              </button>
            </div>
            {errMsg && (
              <div className="max-w-max text-center text-error py-2 px-4 mt-4 mx-auto rounded-md">
                {errMsg}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgetPassword;
